import * as axios from "axios";
 // '/d4w/front/'
// 'http://127.0.0.1:10008/profsalon/front/'
const instance = axios.create({
    baseURL: (window.location.hostname==="localhost")?
        "http://127.0.0.1:10012/rb/front/": "/flowlu/front/",
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    }
});

const sendAPI = {
    saveToken(token, appId) {
        return instance.post(`/`, {token, appId} );
    },
    auth(token, service) {
        return instance.post(`/`, {"auth":{token}, 'service': service} );
    },
    setIntegration(status, appId) {
        return instance.post(`/`, {"integration": {status, appId}} );
    },
    saveLogin(login, appId){
        return instance.post(`/`, {"login": {login, appId}} );
    },
    saveID(id, appId){
        return instance.post(`/`, {"id": {id, appId}} );
    }
}

export default sendAPI